import { render, staticRenderFns } from "./registrosAsistenciaTrabajador.vue?vue&type=template&id=55e1afc8"
import script from "./registrosAsistenciaTrabajador.vue?vue&type=script&lang=js"
export * from "./registrosAsistenciaTrabajador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports